import React from 'react'

const bar_chart = () => {
  return (
    <div>bar_chart</div>
  )
}

export default bar_chart